import styled from 'styled-components';

import { device } from 'commons';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const ConsignmentsSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 30%;
  min-width: 400px;
  padding-top: 30px;
  background-color: ${({ theme }) => theme.neutral_200};
  overflow: hidden;
  gap: 20px;

  @media (max-width: ${device.mobile}px) {
    width: 90%;
    padding-left: 0;
    min-width: auto;
  }
`;

export const DetailsSection = styled.section`
  flex: 1;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral_100};

  @media (max-width: ${device.mobile}px) {
    width: 100vw;
    margin: 0;
  }
`;
